import { render, staticRenderFns } from "./HistoricoInformeData.vue?vue&type=template&id=7f61a934&scoped=true&"
import script from "./HistoricoInformeData.vue?vue&type=script&lang=ts&"
export * from "./HistoricoInformeData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61a934",
  null
  
)

export default component.exports